<app-default>
  <div class="container pt-5 pb-5">
    <h1 class="title">Chính sách thanh toán</h1>
    <p>Khách hàng khi sử dụng dịch vụ của <strong>Eco Express</strong>, điều này đồng nghĩa thỏa thuận hai bên đã được chấp nhận. Quý khách có nghĩa vụ thanh toán phí dịch vụ và các khoản phí như trong thỏa thuận bằng các hình thức sau:</p>
    <p>Trả tiền mặt tại bộ phận kế toán công ty Eco Expres, và nhận hóa đơn.</p>
    <p>Thanh toán trực tuyến bằng hình thức chuyển khoản. Thông tin chuyển khoản sẽ được thông báo kèm theo Email cho quý khách.</p>
    <p>Thanh toán ký quỹ hoặc trả chậm theo thỏa thuận 2 bên.</p>
  </div>
</app-default>
